module.exports = "<button [ngClass]=\"type\" (click)=\"sendParent()\" type=\"button\" [disabled]=\"disabled\">{{text}}</button>\n"